import InstagramMedia from './InstagramMedia';

export default InstagramMedia;
